<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.title" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="title" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.subTitle" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="subTitle" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.avatar" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="avatar" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card>
          <list>
            <list-item
              @click="log('click', 'list-item', item)"
              tag="router-link"
              v-for="(item, index) in list"
              :key="index"
              :disabled="disabled ? item.disabled : false"
              :to="item.to">
              <list-item-avatar v-if="avatar">
                <avatar
                  :bg-color="$root.colors.primary"
                  :text="item.avatar"
                  :tile="false"
                  :bg-color-lightness="$root.colors.bgColorLightness" />
              </list-item-avatar>
              <list-item-content>
                <list-item-content-title v-html="item.title" v-if="title" />
                <list-item-content-sub-title v-html="item.subTitle" v-if="subTitle" />
              </list-item-content>
              <list-item-icon v-if="icon">
                <icon :name="item.icon" :color="$root.colors.primary" :color-lightness="$root.colors.bgColorLightness" />
              </list-item-icon>
            </list-item>
          </list>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageList',
  mixins: [
    methods
  ],
  data () {
    return {
      list: [],
      avatar: true,
      icon: true,
      title: true,
      subTitle: true,
      disabled: false
    }
  },
  mounted () {
    this.getExternalData('menu-list.json', 'list')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/list.vue